var map = {
	"./icon-error.svg": "VBVJ",
	"./icon-success.svg": "5MPy",
	"./logout.svg": "7VC4",
	"./logout_green.svg": "Ayft",
	"./person-gray.svg": "QtIh",
	"./person.svg": "vxuN",
	"./person_green.svg": "dwSv",
	"./person_white.svg": "3+yg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 39